import { AxiosResponse } from 'axios';

import { DownloadHistory } from '@videoblocks/user-service-client';

import { downloadHistoryApi } from './userServiceConfig';

export interface DownloadHistoryParams {
    userId: number;
    search?: string;
    ownerId?: number;
    contentClasses?: Array<'video' | 'audio' | 'image'>;
    page?: number;
    resultsPerPage?: number;
    sort?: string;
    sortDir?: 'asc' | 'desc';
}

const getDownloadHistoryByUserId = async (params: DownloadHistoryParams): Promise<DownloadHistory> => {
    const result = (await downloadHistoryApi.getDownloadHistoryByUserId(params)) as AxiosResponse<DownloadHistory>;
    return result.data;
};

export const DownloadHistoryApi = {
    getDownloadHistoryByUserId,
};
